import { setTabVisibility as setVisibility } from '@client/redux/modules/clientDevice/actions';
import { RootState } from '@client/redux/types';
import { Store } from 'redux';

type VisibilityChangeType = 'visibilitychange' | 'msvisibilitychange' | 'webkitvisibilitychange';
type HiddenType = 'hidden' | 'msHidden' | 'webkitHidden';

export const checkVisibilityAPI = (): {
    hidden?: HiddenType;
    visibilityChange?: VisibilityChangeType;
} => {
    if (typeof document.hidden !== 'undefined') {
        return {
            hidden: 'hidden',
            visibilityChange: 'visibilitychange',
        };
    }

    if (typeof document.msHidden !== 'undefined') {
        return {
            hidden: 'msHidden',
            visibilityChange: 'msvisibilitychange',
        };
    }

    if (typeof document.webkitHidden !== 'undefined') {
        return {
            hidden: 'webkitHidden',
            visibilityChange: 'webkitvisibilitychange',
        };
    }

    return {};
};

export const getVisibilityChangeEventName = () => {
    const { visibilityChange } = checkVisibilityAPI();

    return visibilityChange;
};

export const getHiddenPropName = () => {
    const { hidden } = checkVisibilityAPI();

    return hidden;
};

export const setTabVisibility = (store: Store<RootState>) => {
    const hidden = getHiddenPropName();

    store.dispatch(setVisibility(!document[hidden]));
};
